<div class="image-container use-transition">
	<a (click)="goToArticle(article.slug)">
		<picture>
			<source media="(min-width: 768px)" [srcset]="article.image">
			<img [src]="article.cover" />
		</picture>

		<div class="video-meta">
			<span class="video-title" [innerHTML]="article.title | safeHtml"></span>
			<span class="video-subtitle" [innerHTML]="article.subtitle | safeHtml"></span>
		</div>

		<div class="gradient"></div>
	</a>
</div>